export { default } from "./tabs-item";
